import React from 'react'
import { FaxDetailsData } from '../../types/intakeQueue.types'
import { FAX_PREVIEW } from '../../constants/intakeQue.constants'
import { formatFaxNumber } from '../../utils/helperFunctions'
import { INTAKE_DOCUMENT } from '../../utils/constants'
import { formatLocalDateWithZone } from '../../utils/date.utils'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'

interface FaxDetails {
  faxData: FaxDetailsData | null
  agentDetails?: {
    record_status: string
    last_name: string
    email: string
    first_name: string
    id: number
  } | null
  parentEntity?: string
  isAePcStatusVisible?: boolean
  intakeType?: string
}

const FaxInfo: React.FC<FaxDetails> = ({
  faxData,
  agentDetails,
  parentEntity,
  isAePcStatusVisible,
  intakeType,
}) => {
  const getAgentName = () => {
    if (agentDetails) {
      return agentDetails?.last_name && agentDetails?.first_name
        ? `${agentDetails?.first_name} ${agentDetails?.last_name}`
        : 'N/A'
    } else if (faxData?.users) {
      return faxData?.users?.first_name && faxData?.users?.last_name
        ? `${faxData?.users?.first_name} ${faxData?.users?.last_name}`
        : 'N/A'
    } else {
      return 'N/A'
    }
  }
  const getAgentEmail = () => {
    if (agentDetails) {
      return `${agentDetails?.email ?? 'N/A'}`
    } else if (faxData?.users) {
      return `${faxData?.users?.email ?? 'N/A'}`
    } else {
      return 'N/A'
    }
  }
  return (
    <div className="px-1 border bg-secondary-50 border-gray-200 mt-2">
      <div
        className={`${
          intakeType === QUEUE_STRINGS?.FAX && isAePcStatusVisible
            ? 'grid grid-cols-4'
            : 'grid grid-cols-3'
        }`}
      >
        <div className="col-span-1 p-2">
          <span className="font-primary block text-xs">
            {parentEntity === INTAKE_DOCUMENT.DOCUMENT
              ? INTAKE_DOCUMENT.RECEIVED_ON
              : FAX_PREVIEW.RECEIVED_FROM}
          </span>
          <strong className="font-primary text-xs  break-words">
            {parentEntity === INTAKE_DOCUMENT.DOCUMENT
              ? formatLocalDateWithZone(faxData?.created_at)
              : faxData?.category_communication_type?.label ===
                QUEUE_STRINGS.MAIL
              ? faxData?.sender_name
              : formatFaxNumber(String(faxData?.sender_name)) ||
                faxData?.received_from}
          </strong>
        </div>
        <div className="col-span-1 p-2">
          <span className="font-primary block text-xs">
            {FAX_PREVIEW.AGENT_NAME}
          </span>
          <strong className="font-primary text-xs  break-words">
            {getAgentName() || 'N/A'}
          </strong>
        </div>

        <div className="col-span-1 p-2">
          <span className="font-primary block text-xs">
            {FAX_PREVIEW.AGENT_EMAIL}
          </span>
          <strong className="font-primary text-xs  break-words">
            {getAgentEmail() || 'N/A'}
          </strong>
        </div>
        {intakeType === QUEUE_STRINGS?.FAX && isAePcStatusVisible ? (
          <div className="col-span-1 p-2">
            <span className="font-primary block text-xs">
              {FAX_PREVIEW.AE_PC_STATUS}
            </span>
            <strong className="font-primary text-xs  break-words">
              {faxData?.c_ae_pc_document?.[0]?.ae_pc_status}
            </strong>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default FaxInfo
